var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopSlider',{staticClass:"mb-5 mt-6",staticStyle:{"margin-top":"85px"}}),_c('AboutAlorFeri',{staticClass:"mb-5 mt-5"}),_c('OurServices',{staticClass:"mb-5 mt-5"}),_c('OurProducts',{staticClass:"mb-5 mt-5"}),_c('NewsAndMediaReports',{staticClass:"mb-5 mt-5"}),_c('LibraryPatrons',{staticClass:"mb-5 mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }